import {Editor} from 'tinymce';
import {MergeTagsItem} from '../types';
import {getMergeTagsList} from '../api/Options';

type ActionFn = (value: string) => void;

const buildMenuItemsRecursive = (editor: Editor, items: MergeTagsItem[], onAction: ActionFn) => {
  return items.map((item: any) => {
    if (item.hasOwnProperty('menu') && item.menu.length) {
      return {
        type: 'nestedmenuitem',
        text: item.title,
        getSubmenuItems: () => buildMenuItemsRecursive(editor, item.menu, onAction)
      }
    }
    return {
      type: 'menuitem',
      text: item.title,
      value: item.value,
      onAction: (api: any) => {
        onAction(item.value);
      },
    }
  });
};

const buildMenuItems = (editor: Editor, onAction: ActionFn) => {
  /*
   * `mergeTagsList` can change, that's why we always recreate the menu item.
   */
  const items: MergeTagsItem[] = getMergeTagsList(editor);

  return buildMenuItemsRecursive(editor, items, onAction);
}

export const generateMenuItemsCallback = (editor: Editor, onAction: ActionFn) =>
  (callback: Function) => callback(buildMenuItems(editor, onAction));

type AutocompleteItem = {
  text: string;
  value: string;
}

export const flattenMergeTagsListForAutocomplete = (items: MergeTagsItem[]): AutocompleteItem[] => {
  /*
   * only flatten for 1 level
   * TODO: flatten all levels
   */
  return items.reduce((acc: any, item: any) => {
    if (item.hasOwnProperty('menu') && item.menu.length) {
      for (let index = 0; index < item.menu.length; index++) {
        const _item = item.menu[index];
        acc.push({
          text: _item.title,
          value: _item.value,
        })
      }
    } else {
      acc.push({
          text: item.title,
          value: item.value,
        })
    }
    return acc;
  }, []);
}

export const filterAutocompleteItems = (items: AutocompleteItem[], pattern: any) => {
  return items.filter((item: AutocompleteItem) =>
    item.text.toLowerCase().indexOf((pattern || '').toLowerCase()) >= 0
  );
}
